import React from 'react'
import classnames from 'classnames'

const Item = ({ label, className, selected, ...rest }) => (
  <li
    className={classnames('cookunity__tab__item', className, { selected })}
    {...rest}>
    {label}
  </li>
)

export default Item



// WEBPACK FOOTER //
// ./src/components/Tabs/Item.jsx